import { CatalogSearchQuery, CatalogSearchQueryKey, defaultQuery } from "./schema"

export function objectToQueryString(obj: object, name: string): string {
    const entries: string[] = []
    for (const [key, value] of Object.entries(obj)) {
        value && entries.push(`${name}.${key}=${value}`)
    }
    return entries.join("&")
}

export function arrayToQueryString(arr: number[], name: string): string {
    return `${name}=${arr.join("|")}`
}

export function toQueryString(query: CatalogSearchQuery): string {
    const entries: string[] = []
    for (const [key, value] of Object.entries(query)) {
        const defaultValue = defaultQuery[key as CatalogSearchQueryKey]
        if (typeof defaultValue === "undefined") {
            continue
        }
        if (Array.isArray(value)) {
            value.length && entries.push(arrayToQueryString(value, key))
            continue
        }
        if (typeof value === "object" && !Array.isArray(value)) {
            const result = objectToQueryString(value, "working_with")
            result.length && entries.push(result)
            continue
        }
        if (defaultValue !== value) {
            entries.push(`${key}=${value?.toString() ?? ""}`)
        }
    }
    return entries.join("&")
}
